import { cn } from '#app/utils/misc'

/**
 * One honest score for how strong a link profile is. Node/bar authority encoding.
 */
export function AuthorityGauge({
	value,
	max = 100,
	label = 'Authority',
	className,
}: {
	value: number
	max?: number
	label?: string
	className?: string
}) {
	const pct = Math.max(0, Math.min(100, (value / max) * 100))
	return (
		<div className={cn('flex flex-col justify-center', className)}>
			<div className="mb-1.5 text-[13px] text-[#8A867D]">{label}</div>
			<div className="mb-2 h-3 overflow-hidden rounded-full bg-[#F0EDE6]">
				<div
					className="from-brand-light to-brand h-full rounded-full bg-gradient-to-r"
					style={{ width: `${pct}%` }}
				/>
			</div>
			<div className="text-brand font-mono text-2xl font-semibold">
				AR {value}
				<span className="text-sm text-[#9A968C]"> / {max}</span>
			</div>
		</div>
	)
}
